import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

interface InviteEntry {
  rkey: string
  uri: string
  cid: string
  slug: string
  repo: string
  isActive: boolean
  createdAt: string
}

interface InviteValue {
  slug: string
  repo: string
  isActive: boolean
  createdAt?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Edit invite - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ statusCode: 404, statusMessage: 'Missing rkey.' })
}

const { data, loading } = useAdminFetch<InviteEntry>(`/api/admin/invites/${rkey.value}`, {
  watch: false,
})

async function save (value: InviteValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/invites/${rkey.value}`, { method: 'PUT', body: value })
  await navigateTo('/admin/invites')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminInviteForm = _resolveComponent("AdminInviteForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit invite" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminInviteForm, {
            key: 0,
            initial: _unref(data),
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(loading))
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'text', 'checkbox']
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})